/* The language banner, held back on screens that own the whole display.
 *
 * `LanguageWelcome` is pinned to the top of the viewport at z-110. On every
 * normal page that is fine -- it sits above the content and the user dismisses
 * it. On Lyn-ID it lands directly on the header and its close button, and Lyn-ID
 * is the one screen in the app whose entire promise is that nothing stands
 * between opening it and taking the photo. Somebody reaching it from a locked
 * phone gets a language question instead of a camera.
 *
 * The nudge is deferred, not lost: it appears on the next screen they open.
 *
 * Only nudges belong in here. Consent UI does not -- see `isBareRoute`.
 */
import { useLocation } from 'react-router-dom';
import LanguageWelcome from './LanguageWelcome';
import { isBareRoute } from '../lib/bareRoutes';

export default function LanguageNudge() {
    const { pathname } = useLocation();
    if (isBareRoute(pathname)) return null;
    // The desktop workspace is English-only and never asks.
    if (typeof window !== 'undefined'
        && (window.uniqappsDesktop?.mode === 'local' || window.growDailyDesktop?.mode === 'local')) {
        return null;
    }
    return <LanguageWelcome />;
}
